import { postNewLead } from '../../components/API';
import { SignUpData } from '../../Types';

export async function addSignUpDataToLead(
  data: SignUpData,
  urlParams: Record<string, unknown>,
) {
  const { firstName, lastName, email, acceptedTerms } = data;
  const id = window.localStorage.getItem('leadId');
  const leadRes = await postNewLead({
    firstName,
    lastName,
    email,
    acceptedTerms,
    id: id === 'undefined' ? undefined : id,
    url_params_on_signup: JSON.stringify(urlParams),
  });
  if (!id) {
    window.localStorage.setItem('leadId', leadRes?.id);
  }
}
